import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs/BehaviorSubject'
import { Observable } from 'rxjs/Observable'
import 'rxjs/add/operator/distinctUntilChanged'

@Injectable()
export class StoreService {
  private searchInput = new BehaviorSubject(null)
  private periodInput = new BehaviorSubject(null)
  private caseIdInput = new BehaviorSubject(null)
  private caseInputOpen = new BehaviorSubject(false)

  private securityProfileResult = new BehaviorSubject(null)

  constructor() {}

  getSecurityProfileNewResultObservable(): Observable<object> {
    return this.securityProfileResult
  }

  setSecurityProfileResult(response: any): void {
    this.securityProfileResult.next(response)
  }

  getSearchInputObservable(): Observable<string> {
    return this.searchInput.distinctUntilChanged()
  }

  setSearchInputBehavior(searchInput: string): void {
    this.searchInput.next(searchInput)
  }

  getPeriodInputObservable(): Observable<string> {
    return this.periodInput.asObservable()
  }

  setPeriodInputBehavior(periodInput: string): void {
    this.periodInput.next(periodInput)
  }

  getOutputCaseByIdObservable(): Observable<string> {
    return this.caseIdInput.asObservable()
  }

  setOutputCaseByIdBehavior(caseIdInput: string): void {
    this.caseIdInput.next(caseIdInput)
  }

  getInputOpenObservable(): Observable<boolean> {
    return this.caseInputOpen.asObservable()
  }

  setInputOpenBehavior(caseInputOpen: boolean): void {
    this.caseInputOpen.next(caseInputOpen)
  }

}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/service/store.service.ts